export default __webpack_public_path__ + "static/media/contact.a35908a8.svg";